import isEmpty from 'is-empty';
import {
  FIX_TIP_INVESTMENT,
  FIX_TIP_INVESTMENT_ERROR,
  FIX_TIP_INVESTMENT_LOADING,
  FIX_TIP_INVESTMENT_ERROR_DELETE
} from
  '../../actions/types';

const initialState = {
  success: false,
  fixtipInvestment: {},
  error: '',
  loading: false
};

const fixtipInvestment = (state = initialState, action) => {
  switch (action.type) {
    case FIX_TIP_INVESTMENT:
      return {
        ...state,
        success: !isEmpty(action.fixtip),
        fixtipInvestment: action.fixtip,
        loading: false
      };
    case FIX_TIP_INVESTMENT_ERROR:
      return {
        ...state,
        success: false,
        error: action.error,
        loading: false
      };
    case FIX_TIP_INVESTMENT_ERROR_DELETE:
      return {
        error: ''
      };
    case FIX_TIP_INVESTMENT_LOADING:
      return {
        ...state,
        loading: true
      };
    default:
      return state;
  }
};

export default fixtipInvestment;
